export type ConnectivityView = 'day' | 'month';

export type ConnectivityViewSlice = {
	connectivityView: ConnectivityView;
	setConnectivityView: (view: ConnectivityView) => void;
	resetConnectivityViewSlice: () => void;
};

const initialChartSliceState: Pick<ConnectivityViewSlice, 'connectivityView'> = {
	connectivityView: 'day',
};

export const createConnectivityViewSlice = (
	set: (fn: (state: any) => any) => void,
): ConnectivityViewSlice => ({
	connectivityView: 'day',
	setConnectivityView: (view) =>
		set((state) => ({
			...state,
			connectivityView: view,
		})),
	resetConnectivityViewSlice: () =>
		set((state) => ({
			...state,
			...initialChartSliceState,
		})),
});
